import { render } from "./DocumentType.vue?vue&type=template&id=520896a4&scoped=true"
import script from "./DocumentType.vue?vue&type=script&lang=js"
export * from "./DocumentType.vue?vue&type=script&lang=js"

import "./DocumentType.vue?vue&type=style&index=0&id=520896a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520896a4"]])

export default __exports__